import { useCallback } from 'react';

export const useSeriesScrollPosition = (containerRef, storageKey, series, card) => {
  const getSelectedCard = useCallback(() => {
    const selectedCard = sessionStorage.getItem(storageKey);
    if (!selectedCard) return null;
    return JSON.parse(selectedCard);
  }, [storageKey]);

  const saveSelectedCard = useCallback(() => {
    sessionStorage.setItem(storageKey, JSON.stringify({
      series,
      card
    }));
  }, [card, series, storageKey]);

  const focusSelectedCard = useCallback(() => {
    // visual testing: wait for the edu hub carousels to render before scrolling,
    // otherwise it gets stuck halfway
    setTimeout(() => {
      containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
      sessionStorage.removeItem(storageKey);
    }, 250);
  }, [containerRef, storageKey]);

  return { getSelectedCard, saveSelectedCard, focusSelectedCard };
};
